import { postAnnouncement } from "../../../api/createannouncement";
import { t } from "i18next";
import { clearDB } from "../../../utils/indexedDBService";
import monitoringService from "../../../services/monitoringService";



export function publishFun(
    additionalPhones, setAdditionalPhones, phoneErrors, setPhoneErrors,
    setIsSubmitted, setIsLoading, announcementName, description,
    selectedSubcategory, selectedLocation, videoLink, priceType, price,
    volumeUnit, selectedCategory, userData, tagsArray, images, navigate, setShowErrorModal, showErrorModal, setErrorMessage
) {
    const handlePublish = async () => {
        setIsSubmitted(true);
        setIsLoading(true);

        if (!announcementName) {
            console.error(t("required_title"));
            setShowErrorModal(true);
            setErrorMessage(t("required_title"));
            setIsLoading(false);
            return { announcementId: null };
        }
        if (!description) {
            console.error(t("required_description"));
            setShowErrorModal(true);
            setErrorMessage(t("required_description"));
            setIsLoading(false);
            return { announcementId: null };
        }
        if (!price) {
            console.error(t("required_price"));
            setShowErrorModal(true);
            setErrorMessage(t("required_price"));
            setIsLoading(false);
            return { announcementId: null };
        }
        if (!selectedLocation) {
            console.error(t("required_location"));
            setShowErrorModal(true);
            setErrorMessage(t("required_location"));
            setIsLoading(false);
            return { announcementId: null };
        }
        if (!selectedSubcategory) {
            console.error(t("required_subcategory"));
            setShowErrorModal(true);
            setErrorMessage(t("required_subcategory"));
            setIsLoading(false);
            return { announcementId: null };
        }
        if (!tagsArray || tagsArray.length === 0) {
            console.error(t("required_tags"));
            setShowErrorModal(true);
            setErrorMessage(t("required_tags"));
            setIsLoading(false);
            return { announcementId: null };
        }

        const phoneErrorsList = additionalPhones.map(phone => !phone.trim());
        setPhoneErrors(phoneErrorsList);

        if (phoneErrorsList.some(error => error)) {
            console.error(t("empty_phone_numbers"));
            setShowErrorModal(true);
            setErrorMessage(t("empty_phone_numbers"));
            setIsLoading(false);
            return { announcementId: null };
        }

        const formData = new FormData();
        formData.append("title", announcementName);
        formData.append("video_url", videoLink || "");
        formData.append("description", description);
        formData.append("price_type", priceType);
        formData.append("price", price);
        
        // Convert volumeUnit to server format - server expects enum values
        const unitMapping = {
            "pcs": "piece",
            "kg": "kilogram",
            "g": "kilogram", // gram is not supported, map to kilogram
            "l": "liter",
            "piece": "piece",
            "kilogram": "kilogram",
            "gram": "kilogram", // gram is not supported, map to kilogram
            "liter": "liter",
            "ton": "ton",
            "hectare": "hectare",
            "square_meter": "square_meter",
            "cubic_meter": "cubic_meter",
            "bag": "bag",
            "centner": "centner",
            "head": "head",
            "pair": "pair",
            "meter": "meter",
            "box": "box"
        };
        const validUnits = ['piece', 'kilogram', 'ton', 'liter', 'hectare', 'square_meter', 'cubic_meter', 'bag', 'centner', 'head', 'pair', 'meter', 'box'];
        const unitForServer = unitMapping[volumeUnit] || (validUnits.includes(volumeUnit) ? volumeUnit : 'kilogram');
        
        // Debug log to verify mapping
        console.log('Volume unit mapping:', { 
            input: volumeUnit, 
            output: unitForServer,
            isValid: validUnits.includes(unitForServer)
        });
        
        formData.append("measurement_unit", unitForServer);
        formData.append("isBarter", "false");

        formData.append("category_id", selectedCategory);
        formData.append("subcategory_id", selectedSubcategory);

        // New architecture: creation must always use catalog-based location IDs.
        // selectedLocation is expected to come from country/region/district selector.
        if (selectedLocation?.country_id != null) {
            formData.append("country_id", String(selectedLocation.country_id));
        }
        if (selectedLocation?.region_id != null) {
            formData.append("region_id", String(selectedLocation.region_id));
        }
        if (selectedLocation?.district_id != null) {
            formData.append("district_id", String(selectedLocation.district_id));
        }

        // Safely handle cases where userData may be null/undefined
        formData.append("contactName", userData?.name || "");
        formData.append("contactPhone", userData?.phone_number || "");

        additionalPhones.forEach((phone, index) => {
            formData.append(`additionalPhones[${index}]`, phone);
        });

        tagsArray.forEach(tag => {
            formData.append("tags[]", tag.trim());
        });

        images.forEach(file => {
            formData.append("images", file);
        });

        try {
            const accessToken = localStorage.getItem("access_token");
            const response = await postAnnouncement(formData, accessToken);

            if (response?.announcement_id) {
                localStorage.removeItem("priceType");
                localStorage.removeItem("announcementName");
                localStorage.removeItem("videoLink");
                localStorage.removeItem("description");
                localStorage.removeItem("price");
                localStorage.removeItem("tagsArray");
                localStorage.removeItem("volumeUnit");
                localStorage.removeItem("selectedLocation");
                localStorage.removeItem("selectedCategory");
                localStorage.removeItem("selectedCategoryName");
                localStorage.removeItem("selectedSubcategory");
                localStorage.removeItem("selectedSubcategoryName");
                localStorage.removeItem("images");
                clearDB("savedImages")
                clearDB("savedImageFiles")

                setAdditionalPhones([]);
                setPhoneErrors([]);

                setShowErrorModal(true);
                setErrorMessage(t('createAdSuccess'));

                // Track successful advertisement creation
                monitoringService.trackAdvertise(
                    response.announcement_id,
                    true,
                    null,
                    {
                        categoryId: selectedCategory,
                        subcategoryId: selectedSubcategory,
                        priceType,
                        price,
                        isBarter: false,
                    }
                ).catch(err => {
                    console.warn('Failed to track advertisement:', err);
                });

                // Return announcement_id so it can be used for navigation when user clicks OK
                return { announcementId: response.announcement_id };
            } else {
                const errorMsg = t("announcement_id_missing");
                console.error(errorMsg);
                setShowErrorModal(true);
                setErrorMessage(errorMsg);
                // Track failed advertisement creation
                monitoringService.trackAdvertise(null, false, errorMsg).catch(err => {
                    console.warn('Failed to track advertisement failure:', err);
                });
                return { announcementId: null };
            }
        } catch (error) {
            const errorMsg = error.message || t("error_creating_announcement");
            console.error(errorMsg, error);
            setShowErrorModal(true);
            setErrorMessage(errorMsg);
            // Track failed advertisement creation
            monitoringService.trackAdvertise(null, false, errorMsg).catch(err => {
                console.warn('Failed to track advertisement failure:', err);
            });
            return { announcementId: null };
        } finally {
            setIsLoading(false);
        }
    };

    return { handlePublish };
}